import { useTranslation } from "react-i18next";
import HeroTop from "../components/HeroTop";
import SocialWall from "../components/SocialWall"; // ✅ add this
import BBBTrust from "../components/BBBTrust";

import { useState } from "react";
import {
    ShieldCheck,
    WifiOff,
    Fingerprint,
    BarChart3,
    LucideIcon,
    Rocket,
    Menu,
    X,
} from "lucide-react";

// Optional spacer between Hero and next section
const SectionSpacer = () => (
    <div className="h-1 bg-gradient-to-r from-gray-100 via-white to-gray-100" />
);

export default function Home() {
    const { t } = useTranslation();
    const [openMenu, setOpenMenu] = useState<string | null>(null);
    const [mobileOpen, setMobileOpen] = useState(false);

    return (
        <main className="relative overflow-hidden">
            {/* Hero Section */}
            <HeroTop />

            {/* BBB Trust Section */}
            <BBBTrust size="default" />

            {/* Spacer to ensure content below the Hero isn’t hidden behind the navbar */}
            <SectionSpacer />

            {/* ✅ Social Wall Section */}
            <div className="bg-black text-white">
                <SocialWall />
            </div>

            {/* Future sections */}
            {/* <Features /> */}
            {/* <ContactForm /> */}
        </main>
    );

    
}
